var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.400024C4.69802 0.400024 0.400024 4.69802 0.400024 10C0.400024 15.302 4.69802 19.6 10 19.6C15.302 19.6 19.6 15.302 19.6 10C19.6 4.69802 15.302 0.400024 10 0.400024ZM7.65002 13.979H5.70602V7.72302H7.65002V13.979ZM6.66602 6.95502C6.05202 6.95502 5.65502 6.52002 5.65502 5.98202C5.65502 5.43302 6.06402 5.01102 6.69102 5.01102C7.31802 5.01102 7.70202 5.43302 7.71402 5.98202C7.71402 6.52002 7.31802 6.95502 6.66602 6.95502ZM14.75 13.979H12.806V10.512C12.806 9.70502 12.524 9.15702 11.821 9.15702C11.284 9.15702 10.965 9.52803 10.824 9.88503C10.772 10.012 10.759 10.192 10.759 10.371V13.978H8.81402V9.71803C8.81402 8.93703 8.78902 8.28402 8.76302 7.72202H10.452L10.541 8.59102H10.58C10.836 8.18302 11.463 7.58102 12.512 7.58102C13.791 7.58102 14.75 8.43802 14.75 10.28V13.979V13.979Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f34ae1814800bcb278281fe11c5cc82f.svg";
export { ForwardRef as ReactComponent };